




























import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { CallLog } from '@/types/call'
import { Patient, Worker, Relative } from '@/types/user'
import dayjs from 'dayjs'

@Component({
  components: {
    CallHistoryLogUser: () => import('@/components/call/CallHistoryLogUser.vue')
  }
})
export default class CallHistory extends Vue {
  $store!: ExStore

  @Prop() log!: CallLog

  get date() {
    return this.log.daialedStartDatetime
  }
  get loginUserId() {
    return this.$store.getters['user/userInfo'].id
  }
  get dateStr() {
    return dayjs(this.date).format('M月D日')
  }
  get isCaller() {
    return this.loginUserId === this.log.user.id
  }
  get type() {
    return (this.isMissing ? '不在' : '') + (this.isCaller ? '発信' : '着信')
  }
  get isMissing() {
    if (this.isCaller) {
      return !this.log.calluserSet.some(callUser => callUser.isDaialed)
    } else {
      return this.log.calluserSet.some(
        callUser => callUser.user.id === this.loginUserId && !callUser.isDaialed
      )
    }
  }
  get allPartners(): (Patient | Worker | Relative)[] {
    return this.log.calluserSet.map(receiver => receiver.user)
  }
  get partnersWithoutSelf(): (Patient | Worker | Relative)[] {
    return this.allPartners.filter(user => user.id !== this.loginUserId)
  }
  get partners(): (Patient | Worker | Relative)[] {
    return this.isCaller
      ? this.allPartners
      : [this.log.user, ...this.partnersWithoutSelf]
  }
  get callPartners() {
    return this.$store.getters['call/callPartners']
  }

  handleClickCallButton() {
    this.$store.dispatch('call/updateCallPartners', this.partners)
    this.$store.dispatch('videoCallRoom/call', { users: this.partners })
    this.$store.dispatch('call/displayUserselectModal', false)
  }
}
